/* Atenas Gorras: interacción de las secciones "Atenas" (portada y carrusel). */
(function () {
  "use strict";

  var SWAP_MS = 450;

  function mod(n, m) {
    return ((n % m) + m) % m;
  }

  function readData(root) {
    var el = root.querySelector("[data-atx-products]");
    try {
      return el ? JSON.parse(el.textContent) : [];
    } catch (e) {
      return [];
    }
  }

  // Cambia la imagen de un contenedor con fundido: la nueva entra, la vieja sale.
  function swapImage(box, src, alt) {
    var current = box.querySelector(".atx-swap:not(.is-leaving)");
    if (current && current.getAttribute("src") === src) return;
    var img = document.createElement("img");
    img.className = "atx-swap is-entering";
    img.src = src;
    img.alt = alt || "";
    img.decoding = "async";
    img.draggable = false;
    box.appendChild(img);
    img.getBoundingClientRect();
    requestAnimationFrame(function () {
      img.classList.remove("is-entering");
    });
    box.querySelectorAll(".atx-swap").forEach(function (old) {
      if (old === img) return;
      old.classList.add("is-leaving");
      setTimeout(function () {
        old.remove();
      }, SWAP_MS);
    });
  }

  /* ---------- Portada ---------- */
  function initHero(root) {
    var items = readData(root);
    if (items.length < 2) return;
    var active = 0;
    var media = root.querySelector("[data-atx-main]");
    var price = root.querySelector("[data-atx-price]");
    var name = root.querySelector("[data-atx-name]");
    var buy = root.querySelectorAll("[data-atx-buy]");
    var thumbs = root.querySelector("[data-atx-thumbs]");
    var cards = root.querySelectorAll("[data-atx-card]");

    function render() {
      var item = items[active];
      swapImage(media, item.images[0].src, item.images[0].alt);
      if (price) price.textContent = item.price;
      if (name) name.textContent = item.label;
      buy.forEach(function (a) {
        a.href = item.url;
      });
      if (thumbs) {
        thumbs.innerHTML = "";
        item.images.slice(0, 4).forEach(function (im) {
          var s = document.createElement("span");
          var i = document.createElement("img");
          i.src = im.thumb;
          i.alt = "";
          i.loading = "lazy";
          s.appendChild(i);
          thumbs.appendChild(s);
        });
      }
      // Las tarjetas muestran los demás modelos, en orden
      var others = items
        .map(function (it, idx) {
          return idx;
        })
        .filter(function (idx) {
          return idx !== active;
        });
      cards.forEach(function (card, slot) {
        var idx = others[slot];
        if (idx === undefined) {
          card.parentElement.hidden = true;
          return;
        }
        var it = items[idx];
        card.parentElement.hidden = false;
        card.dataset.index = idx;
        card.setAttribute("aria-label", "Ver la gorra " + it.title + ", " + it.price);
        swapImage(card.querySelector("[data-atx-card-media]"), it.images[0].card, "");
        card.querySelector("[data-atx-card-price]").textContent = it.price;
        card.querySelector("[data-atx-card-name]").textContent = it.title;
        card.querySelector("[data-atx-card-tag]").textContent = it.tagline;
      });
    }

    cards.forEach(function (card) {
      card.addEventListener("click", function () {
        var idx = Number(card.dataset.index);
        if (!isNaN(idx)) {
          active = idx;
          render();
        }
      });
    });
  }

  /* ---------- Carrusel "Escoge la tuya" ---------- */
  function initCarousel(root) {
    var items = readData(root);
    var n = items.length;
    if (!n) return;
    var stage = root.querySelector("[data-atx-stage]");
    var center = root.querySelector("[data-atx-center]");
    var nameEl = root.querySelector("[data-atx-name]");
    var buy = root.querySelector("[data-atx-buy]");
    var buyPrice = root.querySelector("[data-atx-price]");
    var angles = root.querySelector("[data-atx-angles]");
    var SLOTS = n > 1 ? [-2, -1, 0, 1, 2] : [0];
    var pos = 0;
    var view = 0;
    var tiles = new Map();

    function metrics() {
      var w = stage.clientWidth || 1000;
      var small = w < 640;
      return {
        step: small ? w * 0.3 : Math.min(w * 0.25, 300),
        tile: small ? w * 0.24 : Math.min(w * 0.15, 170),
      };
    }

    function transformFor(d, m) {
      var y = d === 0 ? 0 : m.tile * (Math.abs(d) === 1 ? -0.48 : 0.42);
      return "translate(" + d * m.step + "px, " + y + "px) rotate(" + d * 11 + "deg) scale(" + (d === 0 ? 0.95 : 1) + ")";
    }

    function makeTile(item) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "atx-tile";
      b.setAttribute("aria-label", "Ver la gorra " + item.title);
      var img = document.createElement("img");
      img.src = item.images[0].card;
      img.alt = "";
      img.loading = "lazy";
      img.draggable = false;
      b.appendChild(img);
      return b;
    }

    function layout() {
      var m = metrics();
      var wanted = {};
      SLOTS.forEach(function (s) {
        wanted[pos + s] = true;
      });

      // Las fichas que salen del arco se van hacia su lado y desaparecen
      tiles.forEach(function (el, v) {
        if (wanted[v]) return;
        var side = v < pos ? -3 : 3;
        el.style.opacity = "0";
        el.style.transform = transformFor(side, m);
        el.tabIndex = -1;
        tiles.delete(v);
        setTimeout(function () {
          el.remove();
        }, 600);
      });

      SLOTS.forEach(function (s) {
        var v = pos + s;
        var el = tiles.get(v);
        var fresh = !el;
        if (fresh) {
          el = makeTile(items[mod(v, n)]);
          el.style.transition = "none";
          el.style.opacity = "0";
          el.style.transform = transformFor(s < 0 ? -3 : 3, m);
          stage.insertBefore(el, stage.firstChild);
          tiles.set(v, el);
        }
        el.style.width = m.tile + "px";
        el.style.height = m.tile + "px";
        el.style.marginLeft = -m.tile / 2 + "px";
        el.style.marginTop = -m.tile / 2 + "px";
        if (fresh) {
          el.getBoundingClientRect();
          el.style.transition = "";
        }
        el.style.opacity = s === 0 ? "0" : "1";
        el.style.transform = transformFor(s, m);
        el.tabIndex = s === 0 ? -1 : 0;
        el.setAttribute("aria-hidden", s === 0 ? "true" : "false");
        el.onclick = function () {
          go(s);
        };
      });
    }

    function renderCenter() {
      var item = items[mod(pos, n)];
      var im = item.images[view] || item.images[0];
      swapImage(center, im.src, im.alt);
      nameEl.innerHTML = "";
      nameEl.appendChild(document.createTextNode(item.title + " "));
      if (item.tagline) {
        var t = document.createElement("span");
        t.textContent = "· " + item.tagline;
        nameEl.appendChild(t);
      }
      buy.href = item.url;
      buyPrice.textContent = item.price;
      angles.innerHTML = "";
      if (item.images.length > 1) {
        angles.hidden = false;
        item.images.forEach(function (image, i) {
          var b = document.createElement("button");
          b.type = "button";
          b.textContent = image.label;
          b.setAttribute("aria-pressed", i === view ? "true" : "false");
          b.addEventListener("click", function () {
            view = i;
            renderCenter();
          });
          angles.appendChild(b);
        });
      } else {
        angles.hidden = true;
      }
    }

    function go(delta) {
      if (!delta) return;
      pos += delta;
      view = 0;
      layout();
      renderCenter();
    }

    root.querySelectorAll("[data-atx-go]").forEach(function (b) {
      b.addEventListener("click", function () {
        go(Number(b.getAttribute("data-atx-go")));
      });
    });

    stage.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") go(1);
      if (e.key === "ArrowLeft") go(-1);
    });

    // Deslizar con el dedo o el mouse
    var startX = null;
    stage.addEventListener("pointerdown", function (e) {
      startX = e.clientX;
    });
    stage.addEventListener("pointerup", function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      startX = null;
      if (dx < -40) go(1);
      else if (dx > 40) go(-1);
    });

    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        layout();
      }).observe(stage);
    }

    layout();
    renderCenter();
  }

  /* ---------- Apariciones al hacer scroll ---------- */
  function initReveals(scope) {
    var els = scope.querySelectorAll(".atx-reveal:not(.is-in)");
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) {
        el.classList.add("is-in");
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px" }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  function init(scope) {
    scope.querySelectorAll("[data-atx-hero]").forEach(function (root) {
      if (!root.dataset.atxReady) {
        root.dataset.atxReady = "1";
        initHero(root);
      }
    });
    scope.querySelectorAll("[data-atx-carousel]").forEach(function (root) {
      if (!root.dataset.atxReady) {
        root.dataset.atxReady = "1";
        initCarousel(root);
      }
    });
    initReveals(scope);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  // En el editor de temas de Shopify las secciones se recargan al editarlas
  document.addEventListener("shopify:section:load", function (e) {
    init(e.target);
  });
})();
